(ns ui.view.transaction-process.modals.attestation.event
  (:require
   [cljs.core.async :as async]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.attestation :as attestation-actions]
   [frontend.actions.common :as common-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [common.transaction-process.prefill :as prefill]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [ui.state.session.cofx :as session-cofx]
   [ui.state.time.cofx :as time-cofx]
   [ui.view.transaction-process.modals.attestation.model :as model]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.model :as tp-model]))

(defn- upload-pending-files!
  "Upload each pending File to `entity-id`, then call `on-complete` once all
  uploads have settled (success or failure)."
  [{:keys [entity-id files on-complete]}]
  (if (empty? files)
    (on-complete)
    (let [remaining     (atom (count files))
          on-file-done  (fn []
                          (swap! remaining dec)
                          (when (zero? @remaining)
                            (on-complete)))]
      (doseq [file files]
        (let [filename     (oops/oget file "name")
              prog-channel (async/chan)]
          (common-actions/*<-create-op-token
           nil
           (fn [token]
             (attachment-actions/*=>add-attachment
              {:multipart-params {:filename    filename
                                  :description nil
                                  :file        file
                                  :target      entity-id
                                  :token       token}
               :progress         prog-channel}
              (fn [_] (on-file-done))
              (fn [err]
                (logging/error "Upload failed for" filename err)
                (on-file-done))))
           (fn [err]
             (logging/error "Token failed for" filename err)
             (on-file-done))))))))

(rf/reg-fx
 ::create-attestation
 (fn [{:keys [payload pending-files on-success on-error]}]
   (attestation-actions/*->create
    payload
    (fn [resp]
      (let [new-id (-> resp :body :db/id)]
        (upload-pending-files!
         {:entity-id   new-id
          :files       pending-files
          :on-complete (fn [] (rf/dispatch (conj on-success resp)))})))
    (fn [err] (rf/dispatch (conj on-error err))))))

(rf/reg-fx
 ::update-attestation
 (fn [{:keys [process-id slot-attr entity-id attrs condition-diff pending-files on-success on-error]}]
   (let [{:keys [removed-ids
                 condition-updates
                 condition-creates]} condition-diff
         create-count          (count condition-creates)
         create-remaining      (atom create-count)
         failed?               (atom false)
         fail!                 (fn [err]
                                 (when-not @failed?
                                   (reset! failed? true)
                                   (rf/dispatch (conj on-error err))))
         disable-removed!      (fn []
                                 (doseq [condition-id removed-ids]
                                   (entity-actions/*->disable!
                                    condition-id
                                    (fn [_] nil)
                                    (fn [err]
                                      (logging/error "Failed to disable removed attestation condition"
                                                     err)))))
         save-parent!          (fn []
                                 (when-not @failed?
                                   (entity-actions/*->entity-update!
                                    entity-id attrs
                                    (fn [_]
                                      (disable-removed!)
                                      (upload-pending-files!
                                       {:entity-id   entity-id
                                        :files       pending-files
                                        :on-complete (fn [] (rf/dispatch on-success))}))
                                    fail!)))
         save-conditions!      (fn []
                                 (if (seq condition-updates)
                                   (entity-actions/*->entities-update!
                                    condition-updates
                                    (fn [_] (save-parent!))
                                    fail!)
                                   (save-parent!)))
         finish-create!        (fn [_resp]
                                 (swap! create-remaining dec)
                                 (when (and (zero? @create-remaining)
                                            (not @failed?))
                                   (save-conditions!)))]
     (if (zero? create-count)
       (save-conditions!)
       (doseq [{:keys [entity]} condition-creates]
         (attestation-actions/*->create-condition
          {:data       {:process-id     process-id
                        :slot-attr      slot-attr
                        :attestation-id entity-id
                        :condition      entity}
           :on-success finish-create!
           :on-error   fail!}))))))

(rf/reg-event-fx
 ::open
 [rf/trim-v
  (rf/inject-cofx ::session-cofx/session-context)
  (rf/inject-cofx ::time-cofx/today-utc-midnight-ms)]
 (fn [{:keys [db session-context today-utc-midnight-ms]}
      [{:keys [state-path] :as _ctx}
       {:keys [slot-kw attestation-type-label existing-attestation prefill]}]]
   (let [entities (:entities session-context)
         form (if existing-attestation
                (let [att (common/get-entity entities (:db/id existing-attestation))
                      conditions (->> (:attestation/conditions att)
                                      (map (fn [ref] (common/get-entity entities (or (:db/id ref) ref))))
                                      (remove nil?)
                                      (mapv model/condition->edit-row))]
                  (model/init-edit-state
                   {:attestation            att
                    :conditions             conditions
                    :slot-kw                slot-kw
                    :attestation-type-label attestation-type-label}))
                (model/init-create-state
                 {:slot-kw                slot-kw
                  :attestation-type-label attestation-type-label
                  :prefill                (prefill/resolve-prefill
                                           prefill
                                           {:today-utc-midnight-ms today-utc-midnight-ms})}))]
     {:db (-> db
              (assoc-in (tp-model/modal-full-path state-path)
                        {:modal/modal-type (if existing-attestation :attestation-edit :attestation-create)})
              (assoc-in (common/form-full-path state-path) form))})))

(rf/reg-event-db
 ::set-field
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} field value]]
   (assoc-in db (common/form-key-full-path state-path field) value)))

(rf/reg-event-db
 ::set-conditions
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} conditions]]
   (assoc-in db (common/form-key-full-path state-path :conditions) conditions)))

(rf/reg-event-db
 ::add-pending-file
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} file]]
   (update-in db (common/form-key-full-path state-path :pending-files) (fnil conj []) file)))

(rf/reg-event-db
 ::remove-pending-file
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} idx]]
   (update-in db (common/form-key-full-path state-path :pending-files)
              (fn [files]
                (vec (concat (subvec files 0 idx) (subvec files (inc idx))))))))

(rf/reg-event-fx
 ::save
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [state-path process-id] :as ctx} draft?]]
   (let [form          (-> (get-in db (common/form-full-path state-path))
                           (assoc :draft? draft?))
         new-db        (assoc-in db (common/form-full-path state-path)
                                 (assoc form :submitting? true :error nil))
         pending-files (:pending-files form)]
     (if (:edit-mode? form)
       {:db new-db
        ::update-attestation
        {:process-id     process-id
         :slot-attr      (:slot-kw form)
         :entity-id      (:entity-id form)
         :attrs          (model/->update-attrs form)
         :condition-diff (model/condition-diff form)
         :pending-files  pending-files
         :on-success     [::save-success ctx]
         :on-error       [::save-error ctx]}}
       (let [{:keys [attestation-id entities]} (model/->create-payload form)]
         {:db new-db
          ::create-attestation
          {:payload       {:attestation-id attestation-id
                           :process-id     process-id
                           :slot-attr      (:slot-kw form)
                           :entities       entities}
           :pending-files pending-files
           :on-success    [::save-success ctx]
           :on-error      [::save-error ctx]}})))))

(rf/reg-event-fx
 ::save-success
 [rf/trim-v]
 (fn [_ [ctx]]
   (common/save-success-effects ctx)))

(rf/reg-event-db
 ::save-error
 [rf/trim-v]
 (fn [db [{:keys [state-path] :as _ctx} err]]
   (common/save-error-db db
                         {:state-path state-path}
                         err
                         {:log-message     "Failed to save attestation"
                          :fallback-tr-key :transaction-process/save-verification-error})))
